import React from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { AppShell } from '../components/layout/AppShell';
import { companiesApi } from '../lib/api';
import { Skeleton } from '../components/ui/skeleton';

export default function CompanyWorkspace() {
  const { companyId } = useParams();

  const { data: company, isLoading } = useQuery({
    queryKey: ['company', companyId],
    queryFn: () => companiesApi.get(companyId).then((r) => r.data),
    enabled: !!companyId,
  });

  if (isLoading) {
    return (
      <AppShell>
        <div className="p-6"><Skeleton className="h-8 w-48" /></div>
      </AppShell>
    );
  }

  return (
    <AppShell
      companyName={company?.name}
      breadcrumbs={[
        { label: 'Dashboard', href: '/dashboard' },
        { label: 'Companies', href: '/companies' },
        { label: company?.name || 'Company' },
      ]}
    >
      <Outlet context={{ company, companyId }} />
    </AppShell>
  );
}
